import React, { useMemo } from "react";
import Skeleton from "../../../../components/skeleton";

/**
 * Skeleton loader for a chat message.
 * @param {Object} props
 * @param {boolean} props.isUser - Whether the message is from the user or AI.
 * @returns {JSX.Element} The message skeleton component.
 */
const MessageSkeleton: React.FC<{ isUser: boolean }> = ({ isUser }) => {
  return useMemo(
    () => (
      <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
        <div className={`${isUser ? "w-1/3 md:w-1/4" : "w-4/5 md:w-3/4"}`}>
          <Skeleton className={`${isUser ? "h-16" : "h-24"} rounded-2xl p-4`} />
        </div>
      </div>
    ),
    [isUser],
  );
};

export default MessageSkeleton;
